import 'whatwg-fetch';

class LoadMore {
    constructor(props) {
        this.MAIN_ENDPOINT = `${window.ajaxURL}`;

        // Props
        this.props = props;

        // ES6 Rebind
        this.onClickLoadMore = this.onClickLoadMore.bind(this);

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.setState();

        if (this.ui.$loadMoreBtn) {
            this.bindEvents();
        }
    }

    bindUI() {
        this.ui = {};

        this.ui.$loadMore = this.props.$el;
        this.ui.$loadMoreBtn = this.ui.$loadMore.querySelector('.js-loadmore-btn');
        this.ui.$loadMoreTarget = this.ui.$loadMore.querySelector('.js-loadmore-target');
    }

    setState() {
        this.state = {
            ppp: this.ui.$loadMore.getAttribute('data-ppp') * 1,
            offset: this.ui.$loadMore.getAttribute('data-offset') * 1,
            totalPosts: this.ui.$loadMore.getAttribute('data-total-posts') * 1,
            currentType: this.ui.$loadMore.getAttribute('data-type'),
            categorySlug: this.ui.$loadMore.getAttribute('data-category-slug'),
            typeSlug: this.ui.$loadMore.getAttribute('data-type-slug')
        }
    }

    bindEvents() {
        this.ui.$loadMoreBtn.addEventListener('click', this.onClickLoadMore);
    }

    unbindEvents() {
        this.ui.$loadMoreBtn.removeEventListener('click', this.onClickLoadMore);
    }

    destroy() {
        if (this.ui.$loadMoreBtn) {
            this.unbindEvents();
            this.hideButton();
        }
    }

    onClickLoadMore(e) {
        e.preventDefault();

        let formData = new FormData();

        formData.append('action', `ajax_get_${this.state.currentType}`);
        formData.append('offset', this.state.offset);
        formData.append('posts_per_page', this.state.ppp);
        formData.append('category_slug', this.state.categorySlug);
        formData.append('type_slug', this.state.typeSlug);

        fetch(`${this.MAIN_ENDPOINT}`, {
            method: 'POST',
            body: formData
        }).then((res) => {
            return res.json();
        }).then((res) => {
            this.handleData(res);
        }).catch((err) => {
            console.log(err);
        })
    }

    handleData(data) {
        if (data.markupList.length) {
            this.state.offset = this.state.offset + (data.currentResults * 1);

            if (this.state.offset < data.totalResults) {
                this.showButton();
            } else {
                this.destroy();
            }

            this.ui.$loadMoreTarget.innerHTML += data.markupList;

            // Yo, update!
            const event = new CustomEvent("ajax:gotdata");
            document.body.dispatchEvent(event);

            // Yo, update!
            const loadMoreEvent = new CustomEvent("loadmore:loaded");
            document.body.dispatchEvent(loadMoreEvent);
        } else {
            this.destroy();
        }
    }

    hideButton() {
        this.ui.$loadMoreBtn.classList.add('is-hidden');
    }

    showButton() {
        this.ui.$loadMoreBtn.classList.remove('is-hidden');
    }
};

export default LoadMore;
